import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../system/user/user.service';
import {ApiResponse, MesHttpStatusHandlerService} from 'common-shared';
import {AuthService} from '../../core/services/auth.service';

@Component({
  selector: 'mes-workstation-enter-password',
  templateUrl: './enter-password.component.html'
})
export class EnterPasswordComponent implements OnInit {
  userId: string;
  name: string;
  password: string;
  errorResponse: ApiResponse<any>;

  constructor(private router: Router, private authService: AuthService, private userService: UserService, private route: ActivatedRoute,
              private mesErrorHandlerService: MesHttpStatusHandlerService) {
    this.route.params.subscribe(params => {
      this.userId = params.userId;
      this.name = params.name;
    });

    mesErrorHandlerService.http412.subscribe(value => {
      this.errorResponse = value;
    });
  }

  ngOnInit() {
  }

  loginWithPassword() {
    this.authService.loginById(this.userId, this.password);
  }
}
